import { DEFAULT_PROJECT_NAME } from 'constants/projects';
import { FC, useState, useRef, useEffect, ChangeEvent } from 'react';
import { useToggle, useClickAway } from 'react-use';
import { Box, Input, Text } from 'theme-ui';

export const Title: FC<{ name: string; setName: (val: string) => void }> = ({
  name = '',
  setName
}) => {
  const [isVisible, setVisible] = useToggle(false);
  const [value, setValue] = useState(name);
  const input = useRef(null);
  useEffect(() => {
    setValue(name);
  }, [name]);

  const saveNameHandler = () => {
    setVisible(false);
    setName(value || DEFAULT_PROJECT_NAME);
  };
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      setVisible(false);
      setValue(name);
    }
    if (event.key === 'Enter') {
      saveNameHandler();
    }
  };

  useClickAway(input, () => {
    saveNameHandler();
  });

  useEffect(() => {
    if (!isVisible) return;
    input.current?.addEventListener('keydown', handleKeyDown);
    return () => input.current?.removeEventListener('keydown', handleKeyDown);
  }, [input.current, isVisible, value]);

  useEffect(() => {
    if (isVisible) {
      input.current?.focus();
    }
  }, [isVisible, input.current]);

  const onInputChange = (e: ChangeEvent<HTMLInputElement>) => setValue(e.target.value);
  return (
    <Box
      sx={{
        width: '156px',
        ml: '8px'
      }}
      data-test="projects-current-name"
    >
      {isVisible ? (
        <Input
          ref={input}
          sx={{
            fontSize: 2,
            height: '40px',
            color: '#545869',
            width: '156px',
            px: '16px',
            borderRadius: '8px',
            bg: '#f8f8f8',
            '&:focus': {
              border: '0px'
            }
            // border: '.5px solid #C5C5DD'
          }}
          value={value}
          onChange={onInputChange}
          data-test="projects-current-name-input"
        />
      ) : (
        <Text
          onClick={() => setVisible(!isVisible)}
          variant="body"
          color="white"
          sx={{
            fontSize: 2,
            width: '156px',
            height: '40px',
            mb: 0,
            color: '#545869',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'flex',
            px: '16px',
            alignItems: 'center',
            bg: '#f8f8f8',
            borderRadius: '8px'
          }}
          data-test="projects-current-name-text"
        >
          {name}
        </Text>
      )}
    </Box>
  );
};
